// CourseAssignments.js
import React, { useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  FlatList,
  TouchableOpacity,
  SafeAreaView,
} from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useNavigation, useRoute } from '@react-navigation/native';

const CourseAssignments = () => {
  const navigation = useNavigation();
  const route = useRoute();
  const { course } = route.params || {};
  
  const [assignments, setAssignments] = useState([
    {
      id: 'A1',
      title: 'Python Basics Exercise',
      description: 'Complete the basic Python exercises',
      dueDate: '2024-03-01',
      status: 'submitted',
      grade: 'A',
      points: 100,
      maxPoints: 100,
    },
    {
      id: 'A2',
      title: 'Data Structures Assignment',
      description: 'Implement various data structures in Python',
      dueDate: '2024-03-08',
      status: 'pending',
      grade: null,
      points: null,
      maxPoints: 100,
    },
    // Add more assignments...
  ]);

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <MaterialCommunityIcons name="arrow-left" size={24} color="#1f2937" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Assignments</Text>
        <View style={{ width: 24 }} />
      </View>

      <FlatList
        data={assignments}
        keyExtractor={(item) => item.id}
        renderItem={({ item }) => (
          <TouchableOpacity style={styles.assignmentCard}>
            <View style={styles.assignmentHeader}>
              <Text style={styles.assignmentTitle}>{item.title}</Text>
              <View style={[
                styles.statusBadge,
                item.status === 'submitted' ? styles.submittedBadge : styles.pendingBadge
              ]}>
                <Text style={styles.statusText}>
                  {item.status === 'submitted' ? 'Submitted' : 'Pending'}
                </Text>
              </View>
            </View>
            
            <Text style={styles.assignmentDescription}>{item.description}</Text>
            
            <View style={styles.assignmentDetails}>
              <View style={styles.detailItem}>
                <MaterialCommunityIcons name="calendar-clock" size={16} color="#6b7280" />
                <Text style={styles.detailText}>Due: {item.dueDate}</Text>
              </View>
              
              {item.grade && (
                <View style={styles.detailItem}>
                  <MaterialCommunityIcons name="star" size={16} color="#fbbf24" />
                  <Text style={styles.detailText}>Grade: {item.grade}</Text>
                </View>
              )}
            </View>
            
            <View style={styles.progressBar}>
              <View 
                style={[
                  styles.progressFill, 
                  { width: `${(item.points || 0) / item.maxPoints * 100}%` }
                ]} 
              />
            </View>
            
            <View style={styles.pointsContainer}>
              <Text style={styles.pointsText}>
                {item.points || 0}/{item.maxPoints} points
              </Text>
            </View>
            
            <TouchableOpacity style={styles.viewButton}>
              <Text style={styles.viewButtonText}>
                {item.status === 'submitted' ? 'View Submission' : 'Submit Now'}
              </Text>
            </TouchableOpacity>
          </TouchableOpacity>
        )}
        contentContainerStyle={styles.listContainer}
      />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#ffffff',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#1f2937',
  },
  listContainer: {
    padding: 16,
  },
  assignmentCard: {
    backgroundColor: '#f3f4f6',
    borderRadius: 12,
    padding: 16,
    marginBottom: 16,
  },
  assignmentHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 8,
  },
  assignmentTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#1f2937',
    flex: 1,
    marginRight: 8,
  },
  statusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
  },
  submittedBadge: {
    backgroundColor: '#d1fae5',
  },
  pendingBadge: {
    backgroundColor: '#fef3c7',
  },
  statusText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#065f46',
  },
  assignmentDescription: {
    fontSize: 14,
    color: '#6b7280',
    marginBottom: 12,
    lineHeight: 20,
  },
  assignmentDetails: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  detailItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  detailText: {
    fontSize: 12,
    color: '#6b7280',
    marginLeft: 4,
  },
  progressBar: {
    height: 6,
    backgroundColor: '#e5e7eb',
    borderRadius: 3,
    marginBottom: 8,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#667eea',
    borderRadius: 3,
  },
  pointsContainer: {
    marginBottom: 12,
  },
  pointsText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1f2937',
  },
  viewButton: {
    backgroundColor: '#667eea',
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
  },
  viewButtonText: {
    color: '#ffffff',
    fontSize: 14,
    fontWeight: '600',
  },
});

export default CourseAssignments;